import React from "react";
import { Box, Tab, TabList, Tabs, TabPanel } from "@mui/joy";
import {
  tabsPageInnerGrowSx,
  tabsPageRootColumnSx,
  tabsPageTabLabelInheritSx,
  tabsPageTabListVerticalSx,
  tabsPageTabPanelSx,
  tabsPageTabsRootSx,
  tabsPageTabSx,
} from "../../styles/globalStyles";
import DarkTypography from "./DarkTypography";

type TabConfig = {
  label: string;
  component: React.ReactNode;
};

type TabsPageProps = {
  title: string;
  tabs: TabConfig[];
};

export default function TabsPage({ title, tabs }: TabsPageProps) {
  const [value, setValue] = React.useState<number | null>(0);

  const handleChange = (_event: React.SyntheticEvent | null, newValue: string | number | null) => {
    setValue(newValue as number);
  };

  return (
    <Box sx={tabsPageRootColumnSx}>
      <Box sx={tabsPageInnerGrowSx}>
        <Tabs
          orientation="vertical"
          value={value}
          onChange={handleChange}
          aria-label={title}
          sx={tabsPageTabsRootSx}
        >
          <TabList sx={tabsPageTabListVerticalSx}>
            {tabs.map((tab, index) => (
              <Tab key={index} sx={tabsPageTabSx}>
                <DarkTypography level="body-md" component="span" sx={tabsPageTabLabelInheritSx}>
                  {tab.label}
                </DarkTypography>
              </Tab>
            ))}
          </TabList>
          {tabs.map((tab, index) => (
            <TabPanel key={index} value={index} sx={tabsPageTabPanelSx}>
              {tab.component}
            </TabPanel>
          ))}
        </Tabs>
      </Box>
    </Box>
  );
}
